import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLightbulbAltSvg } from "./IconLightbulbAltSvg.mjs";
const IconLightbulbAlt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLightbulbAltSvg, ...iconProps });
};
export {
  IconLightbulbAlt
};
